<template>
    <el-dialog :visible.sync="visible"
        :close-on-click-modal="false"
        append-to-body
        :title="title"
        custom-class="custom-dialog"
        width="500px" >
        <div>
          <label>数据导入：</label>
          <el-input
            style="width: 380px"
            readonly
            v-model="file.name"
            placeholder="请选择导入文件">
            <h-upload
                slot="append"
                ref="uploader"
                :data="params"
                :action="action"
                :show-file-list="false"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :before-remove="beforeRemove"
                :on-success="onSuccess"
                :file-list="files"
                :on-error="onError"
                :on-change="onChange"
                accept=".xls, .xlsx">
              <el-button icon="el-icon-upload"></el-button>
            </h-upload>
          </el-input>
        </div>
        <div class="footer" slot="footer">
            <a v-if="templateURL" class="el-button--text" :href="templateURL" style="float: left;cursor:pointer;" size="small" >{{templateName}}</a>
            <div>
                <el-button @click="onClickCancel" size="small">{{uploading ? '取消导入' : '取消'}}</el-button>
                <el-button type="primary" size="small" @click="importExcel" :loading="uploading">导入</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'h-excel-uploader',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: '/hero/file/upload/add'
        },
        title: {
            type: String,
            default: '数据导入'
        },
        templateName: {
            type: String,
            default: '导入模板下载'
        },
        templateURL: {
            type: String,
            default: ''
        },
        params: {
            type: Object,
            default () {
                return {}
            }
        },
        autoClear: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            visible: false,
            file: {
                name: ''
            },
            uploading: false,
            files: []
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (value) {
                this.visible = value
            }
        },
        visible (value) {
            if (!value) {
                this.onClickCancel()
            } else {
                if (this.autoClear) {
                    this.clear()
                }
            }
            this.$emit('input', value)
        }
    },
    methods: {
        open () {
            this.visible = true
        },
        close () {
            this.visible = false
        },
        clear () {
            if (this.$refs.uploader) {
                this.$set(this, 'file', {name: ''})
                this.$refs.uploader.clearFiles()
            }
        },
        beforeUpload (file) {
           return true
        },
        beforeRemove () {
            return false
        },
        onChange (file, fileList) {
            if (file.percentage !== 0) return // 不考虑上传成功或上传失败
             let whiteList = [
                'application/vnd.ms-excel', // xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // xlsx
            ]
            let isLegalType = whiteList.indexOf(file.type) !== -1
            const type = file.name.substring(file.name.lastIndexOf('.') + 1)
            if (!isLegalType && (type === 'xls' || type === 'xlsx')) {
                isLegalType = true
            }
            if (!isLegalType) {
                this.$tips('导入文件类型有误，仅支持xls和xlsx类型', 'warning')
                this.clear()
            } else {
                this.file = file
                this.files = [file]
            }
        },
        setReady () {
            let index = this.files.findIndex(f => f.uid === this.file.uid)
            if (index !== -1) {
                this.files[index].status = 'ready'
            }
        },
        onSuccess (res, file, fileList) {
            this.uploading = false
            if (res.code === 200 && res.success) {
                this.$tips('导入成功')
                this.$emit('success', res)
            } else {
                this.$emit('error', res)
                this.setReady()
            }
        },
        onError () {
            this.uploading = false
            alert('您的网络出了问题，请稍后重试')
        },
        onClickCancel () {
            if (this.uploading && this.$refs.uploader) {
                this.$refs.uploader.abort(this.file)
                this.uploading = false
                this.setReady()
            } else {
                this.close()
            }
        },
        importExcel () {
            if (!this.file || !this.file.name) {
                this.$tips('请选择导入文件', 'warning')
                return
            }
            this.uploading = true
            this.$refs.uploader.submit()
        }
    },
    beforeDestroy() {
        if (this.uploading) this.$refs.uploader.abort()
    }
}
</script>

<style lang="less" scoped>
.footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/excel-uploader.vue